import { Component } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { ProjectId } from '@models/ProjectConfiguration';
import { ApiService } from '../api.service';
import { Router, RouterModule } from '@angular/router';
import { SynchronizerService } from '../synchronizer.service';
import { ProjectDescription } from '@models/ProjectDescription';
import { CommonModule } from '@angular/common';
import { MarkedPipe } from '../marked.pipe';

@Component({
  selector: 'app-join-project',
  imports: [MatListModule, RouterModule, CommonModule, MarkedPipe],
  templateUrl: './join-project.component.html',
  styleUrl: './join-project.component.scss'
})
export class JoinProjectComponent {
  availableProjects: ProjectDescription[] = [];

  constructor(private synchronizerService: SynchronizerService,
    private api: ApiService,
    private router: Router) {
    this.api.getProjectDescriptions()
      .then((projects) => {
        this.availableProjects = projects.filter((project: ProjectDescription) => project.allow_joins);
      });
  }

  join(project_id: ProjectId) {
    this.api.joinProject(project_id)
      .then(() => {
        this.synchronizerService.reloadUserData()
          .then(() => {
            const project = this.synchronizerService.user$.value?.project(project_id);
            if (project) {
              this.synchronizerService.setProject(project.id, project.fallbackCanon());
              this.router.navigate(['/workspace', project_id]);
            }
          });
      });
  }

}
